import type { VariantProps } from "tailwind-variants";
import { tv } from "tailwind-variants";

import { H1 } from "./text";

const variants = tv({
  variants: {
    variant: {
      default: "grid w-full gap-8 p-6 py-8 md:p-8 lg:p-12 justify-items-start",
      blogPost:
        "grid w-full gap-4 px-0 py-8 md:justify-items-start text-center",
      allCollections:
        "flex justify-between items-baseline gap-8 p-6 md:p-8 lg:p-12",
    },
  },
  defaultVariants: { variant: "default" },
});
type Variants = VariantProps<typeof variants>;
type Props = Variants & {
  children?: React.ReactNode;
  className?: string;
  heading?: string;
};

export function PageHeader({
  children,
  className,
  heading,
  variant,
  ...props
}: Props) {
  return (
    <header {...props} className={variants({ variant, className })}>
      {heading && (
        <H1 width="narrow" size="heading" className="inline-block">
          {heading}
        </H1>
      )}
      {children}
    </header>
  );
}
